export * from './post-rechnungs-vorlage.component';
export * from './post-rechnungs-vorlage.component.module';